import React from "react";

const BS5_Cards = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_Cards Component</h2>
      <p>This is the BS5_Cards component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_Cards;
